import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { BaseStoreBrowserEffects } from './effects/base-store-browser.effects';
import { CityStatePersistenceService } from './services/city-state-persistence.service';
import { CityService } from './services/city.service';

export function cityStatePersistenceFactory(cityPersistenceService: CityStatePersistenceService): () => void {
  return () => cityPersistenceService.sync();
}

export function initOnBrowserFactory(injector: Injector): () => void {
  return () => {
    const cityService = injector.get(CityService);
    cityService.initOnBrowser();
  };
}

@NgModule({
  imports: [EffectsModule.forFeature([BaseStoreBrowserEffects])],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = cityStatePersistenceFactory(inject(CityStatePersistenceService));

      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = initOnBrowserFactory(inject(Injector));

      return initializerFn();
    }),
  ],
})
export class CityFeatureBrowserModule {}
